'use client'

import Image from 'next/image'
import {getBjAvatar} from '@/utils/helpers'

import styles from './Avatar.module.scss'

type AvatarProps = {
  bjId?: string
  src?: string
  alt?: string
  width?: number
  height?: number
  bordered?: boolean
}

const defaultUrl = 'https://profile.img.onlive.vn/LOGO/default.gif'

const Avatar = ({bjId, src, alt, width, height, bordered}: AvatarProps) => {
  const indexOfMinus = bjId ? bjId.indexOf('-') : -1
  const avatarUrl = bjId
    ? getBjAvatar(indexOfMinus >= 2 ? bjId.slice(0, indexOfMinus) : bjId)
    : src
    ? src
    : ''

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (e.currentTarget.src !== defaultUrl) {
      e.currentTarget.src = 'https://profile.img.onlive.vn/LOGO/default.gif'
    }
  }

  return (
    <Image
      className={
        styles.avatar + ' globalAvatar' + (bordered ? ' bordered' : '')
      }
      src={avatarUrl}
      alt={alt ? alt : ''}
      width={width}
      height={height}
      onError={handleError}
    />
  )
}

export default Avatar
